
namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    export class ReportRefundReasonByItemDialog extends Serenity.EntityDialog<ReportRefundReasonByItemRow, any> {
        protected getFormKey() { return ReportRefundReasonByItemForm.formKey; }
        protected getIdProperty() { return ReportRefundReasonByItemRow.idProperty; }
        protected getLocalTextPrefix() { return ReportRefundReasonByItemRow.localTextPrefix; }
        protected getNameProperty() { return ReportRefundReasonByItemRow.nameProperty; }
        protected getService() { return ReportRefundReasonByItemService.baseUrl; }
        protected getDeletePermission() { return ReportRefundReasonByItemRow.deletePermission; }
        protected getInsertPermission() { return ReportRefundReasonByItemRow.insertPermission; }
        protected getUpdatePermission() { return ReportRefundReasonByItemRow.updatePermission; }

        protected form = new ReportRefundReasonByItemForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
               buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;


        }


    }
}